export default __webpack_public_path__ + "static/media/card.9fbcb1c0.svg";